'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

import { sendGTMEvent } from '../lib/sendGTMEvent';

export function GTMErrorPage() {
  const pathname = usePathname();

  useEffect(() => {
    const referrer = document.referrer
      ? new URL(document.referrer).pathname
      : '';
    sendGTMEvent({
      event: 'error_page',
      error_url: pathname,
      referrer
    });
  }, [pathname]);

  return null;
}
